import React, { useState, useEffect, useRef } from 'react'
import Lottie from '../lotties/lottie'
import ReactGA from 'react-ga4'

function InvitePlayers( data ) {
  const[ showInviteButton, setShowInviteButton ] = useState( false )
  const[ currentPlayerIsAloneAtTheTable, setCurrentPlayerIsAloneAtTheTable ] = useState( false )
  const[ showCheckIcon, setShowCheckIcon ] = useState( false )
  let timeToHideCheckIcon = null

  const handleCopyInvitation = () => {
    const roomId = data.roomData.gameConfig.name
    const invitationText = `Join me in the web camera poker game:\nhttps://pokerstream.app/join_room/${roomId}`
    navigator.clipboard.writeText( invitationText )
      .then(() => {
        setShowCheckIcon( true )
      })
      .catch(( err ) => {
        console.error( 'Failed to copy invitation: ', err )
      })
    
    ReactGA.event({
      category: 'InvitePlayers',
      action: 'Copy invitation link',
      label: roomId,
    })
  }

  useEffect(() => {
    checkIfCurrentPlayerIsAloneAtTheTable()
  }, [ data ])

  useEffect(() => {
    let timer

    if( currentPlayerIsAloneAtTheTable ) {
        timeToHideCheckIcon = setTimeout(() => {
        setShowInviteButton( true )
        if( timeToHideCheckIcon ){
            clearTimeout( timeToHideCheckIcon )
            timeToHideCheckIcon = null
        }
      }, 500 )
    } else {
      clearTimeout( timer )
      setShowInviteButton( false )
    }

    return () => {
      clearTimeout( timer )
    }
  }, [ currentPlayerIsAloneAtTheTable ])

  useEffect(() => {
    if( showCheckIcon ) {
    timeToHideCheckIcon = setTimeout(() => {
        setShowCheckIcon( false )
      }, 2000 )

      return () => clearTimeout( timeToHideCheckIcon )
    }
  }, [ showCheckIcon ])

  function checkIfCurrentPlayerIsAloneAtTheTable() {
    let count = 0
    let currentPlayerIsAtTheTable = false

    if( data.roomData && data.roomData.participants && Array.isArray( data.roomData.participants )){
      data.roomData.participants.map(( participant ) => {
        if( participant.participant && ( participant.status === 'player' || participant.status === 'left' )){
          count += 1
          if( participant.participant._id === data.user._id ) {
            currentPlayerIsAtTheTable = true
          }
        }
      })

      if ( count <= 1 && currentPlayerIsAtTheTable ) {
        setCurrentPlayerIsAloneAtTheTable( true )
      } else {
        setCurrentPlayerIsAloneAtTheTable( false ) 
      }
    }else{
      setCurrentPlayerIsAloneAtTheTable( false )
    }
  }

  return (
    <div className={showInviteButton ? "invitePlayer" : "invitePlayerInvisible"}>
      <h3 className='invitePlayer_header' >Game starts when at least 2 players are ready to play</h3>
      <p className='invitePlayer_description'>Why don't you invite some of your friends?</p>
      <button
        className='cardButton cardButtonLobbyGameTypeCardPosition joinGameButton'
        onClick={ handleCopyInvitation }
      >
        <p>Copy invitation link to clipboard</p>
        { showCheckIcon ? (
            <Lottie
                animationName="check"
                loop={ false }
                className={ showCheckIcon ? 'invitePlayerLottie' : 'invitePlayerLottie hidden' } />
        ) : null }
      </button>
    </div>
  )
}

export default InvitePlayers